import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EGoldenSettingsFields = {
	selectValue: 'selectValue',
	date: 'date',
	isImport: 'isImport',
} as const;

export type TGoldenSettingsFields = TValueOfStringRecord<typeof EGoldenSettingsFields>
